import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Banner from "components/mis-survey/sections/banner/Banner";
import styles from "../mis-long-survey/survey.module.css";
import { IoIosArrowRoundForward } from "react-icons/io";
import { Controller, useForm, } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
	conditionalQuizzes as conditionalQuizzesFn,
	generateQuizSchema,
} from "utils/helpers";
import toast from "react-hot-toast";
import {
	useGetSectionById,
	useGetSectionQuestions,
} from "api/hooks";
import RadioInputs from "components/ui/RadioInputBoxes";
import { Backdrop, CircularProgress } from "@mui/material";
import DropDownInput from "components/ui/DropDownInput";

const ACTSurveyUAT = () => {
	const navigate = useNavigate();
	const getQuestions = useGetSectionQuestions(9);
	const getCurrentSection = useGetSectionById(9);

	

	const [formKey, setFormKey] = useState(0);
	const initialConditionalQuizzes = conditionalQuizzesFn([]);

	const hiddenQuizzes = useRef(initialConditionalQuizzes);

	const formSchema = generateQuizSchema(
		getQuestions?.data?.data ?? [],
		hiddenQuizzes
	);


	const {
		control,
		handleSubmit,
		setValue,
		register,
		formState: { errors },
	} = useForm({
		resolver: zodResolver(formSchema),
	});

    const handleSubmitSurvey = () => {
        toast.success("survey submitted successfully");
		setTimeout(() => {
			navigate("/ml-thank-you", { replace: true });
		}, 400);
    }


	const onSubmit = (data) => {
		hiddenQuizzes.current.forEach((id) =>
			setValue(id.toString(), undefined)
		);
        console.log({ data });
		handleSubmitSurvey();
	};

	const updateHiddenQuizes = (logicObj) => {
		const allQuestions = getQuestions.data.data;
		const currentQuizIndex = allQuestions.findIndex(
			(q) => q.quiz_id === logicObj?.currentId
		);
		const nextIndex = allQuestions.findIndex(
			(q) => q.quiz_id === logicObj?.targetedId
		);

		const lastQuizId = allQuestions?.[allQuestions?.length - 1]?.quiz_id;
		const lastQuizIndex = allQuestions.findIndex(
			(q) => q.quiz_id === lastQuizId
		);

		const quizesInbetween = allQuestions
			.slice(
				currentQuizIndex + 1,
				nextIndex === -1 ? lastQuizIndex + 1 : nextIndex
			)
			.map((q) => q.quiz_id);

		//REMOVE action indicates adding the quizes in between that should be skipped
		if (logicObj?.action === "REMOVE") {
			const newHiddenQuizzes = hiddenQuizzes.current?.filter(
				(id) => id !== logicObj?.targetedId
			);

			const updatedHiddenQuizes = [
				...new Set([...newHiddenQuizzes, ...quizesInbetween]),
			];
			hiddenQuizzes.current = updatedHiddenQuizes;
            setFormKey((prev) => prev + 1);
		}

		//ADD action indicates removing the previous hidden quizes in between
		if (logicObj?.action === "ADD") {
			const newHiddenQuizzes = hiddenQuizzes.current?.filter(
				(id) => !quizesInbetween?.includes(id)
			);
			const nestedChildQuizIds = [];

			const targetedQuiz = getQuestions?.data?.data?.find(
				(quiz) => quiz.quiz_id === logicObj?.targetedId
			);

			targetedQuiz?.options?.forEach((option) => {
				if (option?.next_question_id) {
					nestedChildQuizIds.push(option.next_question_id);
				}
			});

			const updatedHiddenQuizes = [
				...new Set([...newHiddenQuizzes, ...nestedChildQuizIds]),
			];

			hiddenQuizzes.current = updatedHiddenQuizes;
            setFormKey((prev) => prev + 1)
		}
	};

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);

	return (
		<section className={styles.container}>
			<Banner
				title={getCurrentSection.data?.data?.[0]?.section_type ?? ""}
				description={
					getCurrentSection.data?.data?.[0]?.Introductory_message ??
					""
				}
			/>

			<Backdrop
				sx={(theme) => ({
					color: "#fff",
					zIndex: theme.zIndex.drawer + 3,
				})}
				open={getQuestions.isLoading}
			>
				<CircularProgress color="inherit" />
				<p className="ml-5 font-light">Loading section</p>
			</Backdrop>
			<form
				onSubmit={handleSubmit(onSubmit)}
				data-testid="main_survey_form"
				key={formKey}
			>
				{getQuestions?.data?.data
					?.filter(
						(quiz) => !hiddenQuizzes.current.includes(quiz?.quiz_id)
					)
					.map((quiz, i) => {
						return (
							<React.Fragment key={i + 1}>
								{
									<>
										{quiz.quiz_type === "SINGLE_SELECT" &&
											quiz.form_element === "RADIO" && (
												<Controller
													name={quiz.quiz_id.toString()}
													control={control}
													render={({ field }) => (
														<RadioInputs
															field={field}
															question={
																quiz.quiz_text
															}
															{...(register(
																quiz.quiz_id.toString()
															),
															{
																required: true,
															})}
															quizOptions={
																quiz.options
															}
                                                            index={i}
															hasError={Boolean(
																errors[
																	quiz.quiz_id
																]
															)}
															errorMessage={
																errors?.[
																	quiz.quiz_id
																]
																	? "this question is required"
																	: ""
															}
															onLogicChange={(
																logic
															) => {
																updateHiddenQuizes(
																	logic
																);
															}}
														/>
													)}
												/>
											)}
										{quiz.quiz_type === "SINGLE_SELECT" &&
											quiz.form_element ===
												"DROP-DOWN" && (
												<Controller
													name={quiz.quiz_id.toString()}
													control={control}
													render={({ field }) => (
														<DropDownInput
															hideOthers={true}
															field={field}
															question={
																quiz.quiz_text
															}
															quizOptions={
																quiz.options
															}
															{...(register(
																quiz.quiz_id.toString()
															),
															{
																required: true,
															})}
															hasError={Boolean(
																errors[
																	quiz.quiz_id
																]
															)}
															errorMessage={
																errors?.[
																	quiz.quiz_id
																]
																	? "this question is required"
																	: ""
															}
                                                            index={i}
															onLogicChange={(
																logic
															) => {
																updateHiddenQuizes(
																	logic
																);
															}}
															hasOthersError={(
																hasError
															) => {
																console.log(
																	hasError
																);
															}}
															onOtherTextChange={({
																id,
																text,
															}) => {
																console.log({
																	id,
																	text,
																});
															}}
														/>
													)}
												/>
											)}
									</>
								}
							</React.Fragment>
						);
					})}

				<div className="!flex !flex-wrap !items-center !gap-2">
					<button type="submit">
						{"Submit"}
						<IoIosArrowRoundForward color="white" size={24} />
					</button>
				</div>
			</form>
		</section>
	);
};

export default ACTSurveyUAT;
